<template>
    <div class="regist">
      <h2>新用户注册</h2>
      <div class="login_box">
        <div class="input_box">
          <span>姓名：</span>
          <div class="ins">
            <input class="comm_input" placeholder="姓名" type="text" maxlength="5" v-model="name" />
          </div>
        </div>
        <div class="input_box">
          <span>手机：</span>
          <div class="ins">
            <input class="comm_input" placeholder="手机号" type="text" v-model="mobile" />
          </div>
        </div>
        <div class="input_box marb0">
          <span>密码：</span>
          <div class="ins">
            <input class="comm_input"  placeholder="密码" type="password" minlength="6" v-model="password" />
          </div>
        </div>
        <div class="input_box">
          <span></span>
          <div class="ins">
            <p @click="$router.push({path: 'login',})">有账号？前往登录吧</p>
          </div>
        </div>
        <div class="input_box">
          <span>地址：</span>
          <div class="ins">
            <input class="comm_input" placeholder="奖品邮寄地址" type="text" v-model="address" />
          </div>
        </div>
        <div class="input_btn">
          <span></span>
          <button class="sub_btn co_bth" @click="login">注册</button>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Regist",
        data() {
            return {
                mobile: "",
                password: "",
                name:'',
                address:''
            };
        },
        methods: {
            validateMobile(mobile) {
                return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
            },
            check_other_char(str)
            {
                var arr = ["&", "\\", "/", "*", ">", "<", "@", "!"];
                for (var i = 0; i < arr.length; i++)
                {
                    for (var j = 0; j < str.length; j++)
                    {
                        if (arr[i] == str.charAt(j))
                        {
                            return true;
                        }
                    }
                }
                return false;
            },
            login() {
                if (!this.name) {
                    alert("请填写用户名");
                    return;
                }
                if (!this.mobile) {
                    alert("请填写手机号");
                    return;
                }
                if (!this.password) {
                    alert("请填写密码");
                    return;
                }
                if (!this.address){
                    alert("请填写收货地址");
                    return;
                }

                if(this.password&&this.mobile){
                    if (!this.validateMobile(this.mobile)){
                        alert('手机号码格式不正确')
                    } else {
                        this.$axios({
                            url:'https://api.hainanfa.org.cn/guess/Add_Guess_User',
                            method:'post',
                            params:{
                                name:encodeURI(this.name),
                                mobile:this.mobile,
                                password: this.password,
                                address:encodeURI(this.address)
                            },
                            headers:{
                                'Content-Type':'application/json;charset=utf-8'
                            }
                        }).then(res=>{
                            console.log(res)
                            if (res.data.status == 0){
                                this.$router.replace('/login')
                            }else if(res.data.status == 400003){
                                alert('该用户已注册')
                                this.$router.replace('/login')
                            }else{
                                console.log('服务器')
                            }
                        }).catch(err=>{
                            console.log(err);
                            alert('请验证你填写的信息')
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
  .regist{
    padding: 40px 10px;
  }
  .regist h2{
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #000000;
    margin: 24px 0;
  }
  .login_box{
    height: 200px;
  }
  .login_box .input_box{
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .input_box span{
    flex: 0 0 70px;
  }
  .ins{
    width: 100%;
  }
  .ins p{
    font-size: 12px;
    color: #666666;
    line-height: 1.5em;
    margin-top: 12px;
  }
  .input_btn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .input_btn span{
    flex: 0 0 70px;
    text-align: right;
    padding-right: 12px;
  }
  .login_box .marb0{
    margin-bottom: 0;
  }
</style>
